import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    console.log(window.gtag)
  }

  addToCart(event) {
    const product = JSON.parse(event.currentTarget.dataset.product);

    if (window.gtag && product) {
      window.gtag('event', 'add_to_cart', {
        currency: 'BRL',
        value: product.price_cents / 100,
        items: [
          {
            item_id: product.id,
            item_name: product.name,
            item_variant: product.sku,
            price: product.price_cents / 100,
            quantity: 1
          }
        ]
      });
    }
  }
}
